import angular from 'angular';

import './acquirer_details/controller';
import './invoicing_emails/controller';

angular.module("merchant.application.page.inStore.card", [
]).controller("merchant.application.page.inStore.card.controller", [
    "$rootScope", "$scope", "$controller",
    function($rootScope, $scope, $controller) {
        $controller("merchant.application.page.inStore.controller", {$scope: $scope});

        $rootScope.headerPage = [
            {
                text: "Acquirer details",
                link: "in-store/card/acquirer-details",
                name: "card-acquirer-details",
                permissions: "VIEW_POS_CARD"
            },
            {
                text: "Invoicing emails",
                link: "in-store/card/invoicing-emails",
                name: "card-invoicing-emails",
                permissions: "VIEW_INVOICING_EMAIL"
            },
        ];
    }
]);
